import React from 'react';
import { Trash2, X, CheckSquare } from 'lucide-react';

/** Toggle button shown above a table to enter bulk-select mode. */
export function BulkSelectToggle({ onClick, disabled }) {
  return (
    <button className="btn btn-secondary" onClick={onClick} disabled={disabled}>
      <CheckSquare size={16} /> Select
    </button>
  );
}

/** Toolbar shown above a table while in bulk-select mode. */
export default function BulkSelectBar({ selectedCount, onDelete, onCancel, disabled }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '0.75rem',
        background: 'var(--bg-secondary)',
        border: '1px solid var(--border-color)',
        borderRadius: 'var(--radius-md)',
        padding: '0.75rem 1.1rem',
        marginBottom: '1rem',
      }}
    >
      <span style={{ fontWeight: 600 }}>{selectedCount} selected</span>
      <div style={{ display: 'flex', gap: '0.6rem' }}>
        <button className="btn btn-secondary" onClick={onCancel} disabled={disabled}>
          <X size={16} /> Cancel
        </button>
        <button className="btn btn-danger" onClick={onDelete} disabled={disabled || selectedCount === 0}>
          <Trash2 size={16} /> Delete
        </button>
      </div>
    </div>
  );
}
